// REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

// LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Chat
export const GET_CHAT = "/get-chat";
export const ADD_CHAT = "/add-chat";
export const DELETE_CHAT = "/delete-chat";
export const BOOKMARK_CHAT = "/delete-chat";

// MailBox
export const GET_MAIL = "/get-mail";
export const DELETE_MAIL = "/delete-mail";
export const UNREAD_MAIL = "/unread-mail";
export const STARED_MAIL = "/stared-mail";
export const TRASH_MAIL = "/trash-mail";

// Calendar
export const GET_EVENT = "/get-event";
export const ADD_EVENT = "/add-event";
export const UPDATE_EVENT = "/edit-event";
export const DELETE_EVENT = "/delete-event";

// Category
export const GET_CATEGORY = "/get-category";
export const DELETE_CATEGORY = "/delete-category";


// HR Management
// Employee List
export const GET_EMPLOYEE = "/get-employee";
export const ADD_EMPLOYEE = "/add-employee";
export const UPDATE_EMPLOYEE = "/edit-employee";
export const DELETE_EMPLOYEE = "/delete-employee";

// Holidays
export const GET_HOLIDAYS = "/get-holidays";
export const ADD_HOLIDAYS = "/add-holidays";
export const UPDATE_HOLIDAYS = "/edit-holidays";
export const DELETE_HOLIDAYS = "/delete-holidays";

// Leaves Manage Employee
export const GET_LEAVE_MANAGE_EMPLOYEE = "/get-leave-manage-employee";

// Leave Manage (HR)
export const GET_LEAVE_MANAGE_HR = "/get-leave-manage-hr";
export const ADD_LEAVE_MANAGE_HR = "/add-leave-manage-hr";
export const UPDATE_LEAVE_MANAGE_HR = "/edit-leave-manage-hr";
export const DELETE_LEAVE_MANAGE_HR = "/delete-leave-manage-hr";

// Attendance
// Attendance (HR)
export const GET_ATTENDANCE = "/get-attendance";

// Main Attendance
export const GET_MAIN_ATTENDANCE = "/get-main-attendance";

// Departments
export const GET_DEPARTMENTS = "/get-departments";
export const ADD_DEPARTMENTS = "/add-departments";
export const UPDATE_DEPARTMENTS = "/edit-departments";
export const DELETE_DEPARTMENTS = "/delete-departments";

// Sales
// Estimates
export const GET_ESTIMATES = "/get-estimates";
export const ADD_ESTIMATES = "/add-estimates";
export const UPDATE_ESTIMATES = "/edit-estimates";
export const DELETE_ESTIMATES = "/delete-estimates";

// Payments
export const GET_PAYMENTS = "/get-payments";

// Expenses
export const GET_EXPENSES = "/get-expenses";
export const ADD_EXPENSES = "/add-expenses";
export const UPDATE_EXPENSES = "/edit-expenses";
export const DELETE_EXPENSES = "/delete-expenses";

// Payroll
// Employee Salary
export const GET_EMPLOYEE_SALARY = "/get-employee-salary";
export const ADD_EMPLOYEE_SALARY = "/add-employee-salary";
export const UPDATE_EMPLOYEE_SALARY = "/edit-employee-salary";
export const DELETE_EMPLOYEE_SALARY = "/delete-employee-salary";

// Notes
export const GET_NOTES = "/get-notes";
export const ADD_NOTES = "/add-notes";
export const UPDATE_NOTES = "/edit-notes";
export const DELETE_NOTES = "/delete-notes";

// Social
// Friends
export const GET_SOCIAL_FRIENDS = "/get-social-friends";

// Events
export const GET_SOCIAL_EVENTS = "/get-social-event";
export const ADD_SOCIAL_EVENTS = "/add-social-event";
export const UPDATE_SOCIAL_EVENTS = "/edit-social-event";
export const DELETE_SOCIAL_EVENTS = "/delete-social-event";

// invoice
export const GET_INVOICE_LIST = "/get-invoice-list"

// Users
// List View
export const GET_USER_LIST = "/get-userlist";
export const ADD_USER_LIST = "/add-userlist";
export const UPDATE_USER_LIST = "/edit-userlist";
export const DELETE_USER_LIST = "/delete-userlist";

// Grid View
export const GET_USER_GRID = "/get-usergrid";
export const ADD_USER_GRID = "/add-usergrid";
export const UPDATE_USER_GRID = "/edit-usergrid";
export const DELETE_USER_GRID = "/delete-usergrid";

 



// Dashbord
export const GET_USER =`/manager/viewusers`
export const GET_MAIN_ACCOUNT=`/admin/getMainAccountDetails`
export const GET_GOLD_SOLD_VALUE=`/admin/viewGoldSoldValue`
export const GET_GOLD_WEIGTH = `/admin/viewGoldWeight`
export const GET_OUTSTANDING =`/admin/viewOutstandingpayout`
export const GET_SHIPMENT = `/admin/viewShipment`
export const GET_SHIPMENT_ORDERWISE = "/admin/viewShipmentOrderWise"
export const GET_VENDOR_PENDING = `/admin/viewVendorPending`
export const TEMP=`/admin/getTodaysPendingShipments`
export const VIEW_USER='/admin/viewusers'
export const VIEW_MANAGER='/admin/viewCollectionDateWise'
export const VIEW_PROFITLOSS='/admin/viewProfitLoss'
export const VIEW_DASHBORD='admin/viewDashbord'

//vendor
export const VIEW_VENDOR='/admin/viewVendor'
export const CREATE_VENDOR='/admin/vendorCreation'
export const VIEW_DEPOSIT='/admin/viewDeposit'
export const VIEW_PURCHASE='/admin/viewPurchase'
export const VIEW_VENDORTRANSACTION='/admin/viewVendorTransaction'
export const CREATE_DEPOSIT='/manager/deposit'
export const VIEW_PURCHASE_DEPOSIT='/admin/viewDepositAndPurchase'
export const CREATE_PURCHASE='/manager/Purchase'
export const VIEW_SALE='/admin/viewSale'
export const CREATE_SALES='/manager/salesReport'

//shipment 
export const CREATE_SHIP = '/manager/shipment'
export const SHIP_DELIVERY='/manager/deliveryentry'
//manager
export const CREATE_MANAGER='/admin/createManager' 

//collection
export const VIEW_TRANSACTION='/admin/viewTransactionHistory'
export const ADD_COLLECTION="/manager/addCollection"
export const VIEW_FULLUSERS="/admin/viewFullUser"
export const CUSTOMER_CLOSING="/manager/customerClosing"

//customers
export const CREATE_CUSTOMERS = "/manager/createUser"
export const VIEW_MANGERUSERS='/manager/viewManagerUser'

//group
export const VIEW_GROUP = "/admin/viewGroup"

//admin login
export const ADMIN_LOGIN = `/admin/adminLogin`

//group
export const CREATE_GROUP='/admin/createGroup'
export const VIEW_GLOBAL='admin/viewGlobalValues'
export const EDIT_GLOBAL = 'admin/editGlobalValues';